import Vue from 'vue'
import VueRouter from 'vue-router'
import {
  getUserAccessToken,
  getBranchAccessToken,
  getRole
} from '@/assets/js/auth'

import store from '@/store'
import Auth from './modules/Auth'
import dashBoard from './modules/dashboard'
import statement from './modules/statement'
import queuepage from './modules/queuepage'
import appointment from './modules/appointment'
import patient from './modules/patient'
import opdreport from './modules/opdreport'
import ingredient from './modules/ingredient'
import DrugFormula from './modules/DrugFormula'
import product from './modules/product'
import stock from './modules/stock'
import pos from './modules/pos'
import service from './modules/service'
import setting from './modules/setting'
import course from './modules/course'
import doctor from './modules/doctor'
import myaccount from './modules/myaccount'
import posOrders from './modules/posOrders'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: () => {
      const role = getRole()
      const tokenUser = getUserAccessToken()
      const tokenBranch = getBranchAccessToken()
      const creditPackage = store.getters['Credit/creditPackage']

      if (!tokenUser) {
        return { name: 'LogoutPage' }
      }

      if (!tokenBranch) {
        return { name: 'LogoutPage' }
      }
      switch (role) {
        case 'owner':
          if (creditPackage === 'Silver' || creditPackage === 'Gold') {
            return { name: 'DashBoard' }
          }
          return { name: 'QueuePage' }

        case 'admin':
          return { name: 'TreatmentReport' }
        default:
          return { name: 'QueuePage' }
      }
    },
    meta: {
      auth: true
    }
  },
  Auth,
  myaccount,
  dashBoard,
  statement,
  queuepage,
  appointment,
  patient,
  opdreport,
  doctor,
  ingredient,
  DrugFormula,
  product,
  stock,
  pos,
  posOrders,
  service,
  course,
  setting,
  {
    path: '/*',
    name: 'PageNotFound',
    component: () => import('@/views/errorPage/404.vue'),
    meta: {
      layout: 'Blank'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const tokenUser = getUserAccessToken()
  const tokenBranch = getBranchAccessToken()

  if (to.meta?.auth) {
    if (!tokenUser) {
      return router.replace({ name: 'LogoutPage' })
    }
    if (!tokenBranch) {
      return router.replace({ name: 'LogoutPage' })
    }
  }
  // if (tokenUser && tokenBranch && to.name === 'Register') {
  //   return router.replace({ name: 'DashBoard' })
  // }
  // if (tokenUser && tokenBranch && to.name === 'LoginPage') {
  //   return router.replace({ name: 'DashBoard' })
  // }
  // if (tokenUser) {
  //   return router.replace({ name: 'ChooseClinic' })
  // }

  return next()
})

export default router
